import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';

@Component({
  selector: 'app-special-box',
  templateUrl: './special-box.component.freeplay.html',
  styleUrls: ['./special-box.component.scss']
})
export class SpecialBoxComponent implements OnInit {
  @Input() systemLogo: boolean = false;
  @Input() raysBox: boolean = true;
  public sys: string;
  public subs: Subscription;

  constructor(protected lotto: LottosService) {}

  ngOnInit(): void {
    this.setSystemLogo();
  }

  setSystemLogo(): void {
    this.subs = this.lotto.lottoObservable$
    .subscribe((lottoObj) => {
      this.sys = lottoObj['system'];
    });
  }

  get setClass() {
    return this.systemLogo ? 'special-box-system ' + this.sys : 'special-box-lotto';
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
